import React, { useEffect, useState } from "react";
import Header from "./Header";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button, Modal } from "react-bootstrap";
import Footer from "./Footer";

function MyDevice() {
  let dealer_id = localStorage.getItem("dealer_id");
  let token = localStorage.getItem("token");
  const LoginNumber = localStorage.getItem("LoginNumber");
  const server_url = localStorage.getItem("server_url");
  const thisDeviceToken = localStorage.getItem("token");
  const navigate = useNavigate();

  const [currentDevice, setCurrentDevice] = useState(null);
  const [otherDevices, setOtherDevices] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    check_user();
    getProductDetails();
  }, []);

  const getProductDetails = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_mobile", LoginNumber);

      const res = await axios.post(
        `${server_url}check_dealer_login.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (res.data.status === "1") {
        const allDevices = res.data.result;

        const current = allDevices.find(
          (d) => d.dealer_device_id === thisDeviceToken,
        );

        if (current) {
          setCurrentDevice({
            id: current.check_id,
            name: current.dealer_device_name,
            location: "",
            time: current.last_login_time,
            tokens: current.dealer_device_id,
          });

          const others = allDevices.filter(
            (d) => d.dealer_device_id !== thisDeviceToken,
          );

          setOtherDevices(
            others.map((d) => ({
              id: d.check_id,
              name: d.dealer_device_name,
              location: "",
              time: d.last_login_time,
              tokens: d.dealer_device_id,
            })),
          );
        } else {
          setCurrentDevice(null);
          setOtherDevices(
            allDevices.map((d) => ({
              id: d.check_id,
              name: d.dealer_device_name,
              location: "",
              time: d.last_login_time,
              tokens: d.dealer_device_id,
            })),
          );
        }
      } else {
        setCurrentDevice(null);
        setOtherDevices([]);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("check_device_token", selectedDevice.tokens);

      const res = await axios.post(
        `${server_url}dealer_logout_web.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
      if (res.data.status === "1") {
        toast.success("Device logged out successfully");
        setShowModal(false);
        getProductDetails();
        check_user();
      } else {
        toast.warning(res.data.message || "Logout failed");
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  };

  const check_user = async () => {
    const formData = new FormData();
    formData.append("company_id", "2");
    formData.append("dealer_id", dealer_id);
    formData.append("device_token", token);
    await axios
      .post(`${server_url}check_dealer.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res1) => {
        if (res1.data.status === "1") {
          localStorage.setItem(
            "local_overdue_amount",
            res1.data.result[0].overdue_amount,
          );
          localStorage.setItem(
            "local_dealer_os",
            res1.data.result[0].dealer_os,
          );
          localStorage.setItem("order_date", res1.data.result[0].order_date);
          localStorage.setItem(
            "local_items_in_cart",
            res1.data.result[0].items_in_cart,
          );
          localStorage.setItem(
            "local_current_order_status",
            res1.data.result[0].current_order_status,
          );
          localStorage.setItem(
            "local_order_final_total_with_gst",
            res1.data.result[0].order_final_total_with_gst,
          );
          localStorage.setItem("local_order_id", res1.data.result[0].order_id);
          localStorage.setItem(
            "local_dealer_firm_name",
            res1.data.result[0].dealer_firm_name,
          );
        } else {
          navigate("/Logout");
        }
      });
  };

  return (
    <React.Fragment>
      <Header />
      <div className="device-page">
        <Container className="py-4">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3" style={{ color: "#666666" }}>
                Loading devices...
              </p>
            </div>
          ) : (
            <>
              <h2 className="section-title mb-4">Manage Your Devices</h2>
              {currentDevice && (
                <Row className="mb-4">
                  <Col xs={12}>
                    <Card className="current-device-card">
                      <Card.Body className="d-flex justify-content-between align-items-center">
                        <div>
                          <h5 className="device-name mb-1">
                            <i className="fa fa-mobile me-2"></i>
                            {currentDevice.name} (Current)
                          </h5>
                          <p className="device-time mb-0">
                            Last used: {currentDevice.time}
                          </p>
                        </div>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => {
                            setSelectedDevice(currentDevice);
                            setShowModal(true);
                          }}
                        >
                          Logout
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}

              {otherDevices.length > 0 && (
                <>
                  <h4 className="other-devices-title mb-3">Other Devices</h4>
                  <Row className="g-3">
                    {otherDevices.map((device) => (
                      <Col xs={12} sm={6} md={4} lg={3} key={device.id}>
                        <Card className="device-card">
                          <Card.Body className="d-flex justify-content-between align-items-center">
                            <div>
                              <h6 className="device-name mb-1">
                                <i className="fa fa-mobile me-2"></i>
                                {device.name}
                              </h6>
                              <p className="device-time mb-0">
                                Last used: {device.time}
                              </p>
                            </div>
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => {
                                setSelectedDevice(device);
                                setShowModal(true);
                              }}
                            >
                              Logout
                            </Button>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </>
              )}

              {otherDevices.length === 0 && !currentDevice && (
                <div className="empty-state text-center py-5">
                  <i
                    className="fa fa-mobile fa-3x mb-3"
                    style={{ color: "#999999" }}
                  ></i>
                  <h5 style={{ color: "#000000" }}>No other devices found.</h5>
                  <p className="mb-0" style={{ color: "#666666" }}>
                    You're only logged in on this device.
                  </p>
                </div>
              )}
            </>
          )}
        </Container>

        {/* Confirmation Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Logout</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to logout from{" "}
            <strong>{selectedDevice?.name}</strong>?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleLogout}>
              Logout
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Footer />

      <style jsx>{`
        .device-page {
          background: #ffffff;
          min-height: 100vh;
          color: #000000;
          font-family:
            -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }

        .section-title {
          color: #000000;
          font-size: 2rem;
          font-weight: 700;
          border-bottom: 2px solid #db4437;
          padding-bottom: 10px;
          display: inline-block;
        }

        .other-devices-title {
          color: #000000;
          font-size: 1.5rem;
          font-weight: 600;
        }

        /* Current Device Card */
        .current-device-card {
          background: #ffffff;
          border: 1px solid #e5e5e5;
          border-radius: 12px;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
        }

        .current-device-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          border-color: #db4437;
        }

        /* Device Cards */
        .device-card {
          background: #ffffff;
          border: 1px solid #e5e5e5;
          border-radius: 12px;
          transition: all 0.3s ease;
          height: 100%;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        }

        .device-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
          border-color: #db4437;
        }

        .device-name {
          color: #000000;
          font-weight: 600;
          margin: 0;
        }

        .device-time {
          color: #666666;
        }

        .btn-outline-danger {
          border-color: #ef4444;
          color: #ef4444;
          padding: 6px 12px;
          font-size: 0.85rem;
          border-radius: 6px;
          transition: all 0.2s ease;
        }

        .btn-outline-danger:hover {
          background: #ef4444;
          color: #fff;
          transform: translateY(-1px);
        }

        /* Empty State */
        .empty-state h5 {
          color: #000000;
          margin-bottom: 0.5rem;
        }

        .empty-state p {
          color: #666666;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .section-title {
            font-size: 1.5rem;
          }

          .other-devices-title {
            font-size: 1.25rem;
          }

          .device-name {
            font-size: large;
          }

          .device-time {
            font-size: 0.85rem;
          }

          .btn-outline-danger {
            padding: 4px 8px;
            font-size: 0.8rem;
          }

          .current-device-card .card-body,
          .device-card .card-body {
            padding: 12px;
          }
        }

        @media (max-width: 480px) {
          .section-title {
            font-size: 1.25rem;
          }

          .current-device-card,
          .device-card {
            margin-bottom: 12px;
          }
        }

        /* Touch Optimizations */
        @media (hover: none) and (pointer: coarse) {
          .device-card:hover,
          .current-device-card:hover {
            transform: none;
          }

          .btn-outline-danger:hover {
            transform: none;
          }
        }
        .device-card {
          border: 1px solid #e5e5e5 !important;
        }
        .current-device-card {
          border: 1px solid #e5e5e5;
        }
      `}</style>
    </React.Fragment>
  );
}

export default MyDevice;
